// mds-dojo — dojo/request/handlers. Response transformers keyed by handleAs.
// register(name, fn) adds custom handlers (RequestManagerLite registers
// "jsonWithDate"). A handler receives the response object and returns response.data.

type Handler = (response: any) => any;

const handlers: Record<string, Handler> = {
  text(response: any) { return response.text; },
  json(response: any) { return response.data = JSON.parse(response.text || 'null'); },
  javascript(response: any) {
    // eslint-disable-next-line no-eval
    return response.data = (0, eval)(response.text);
  },
};

export function register(name: string, handler: Handler): void {
  handlers[name] = handler;
}

export function get(name: string): Handler | undefined {
  return handlers[name];
}

export function apply(response: any, handleAs: string): any {
  const h = handlers[handleAs] || handlers.text;
  const value = h(response);
  return value;
}

const api = { register, get, apply };
export default api;
